<template>
  <div>
    <div class="app-container">
      <el-row :gutter="20">
        <el-col :span="4">
         <div class="li">
           <ul>
             <li
                 v-for="(item, index) in listItems"
                 :key="index"
                 class="li-item"
                 @click="getList(item.label)"
             >
               {{ item.label }}
             </li>
           </ul>
         </div>
        </el-col>

        <el-col :span="20">
          <el-form :model="search" ref="queryForm" size="small" :inline="true" label-width="68px">
            <el-form-item>
              <el-button
                  v-if="hasAddPermission"
                  type="primary"
                  plain
                  icon="el-icon-plus"
                  size="mini"
                  @click="handleAdd"
              >新增</el-button>
            </el-form-item>
            <el-form-item label="" prop="sName">
              <el-input
                  v-model="search"
                  placeholder="请输入姓名"
                  clearable
                  @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            </el-form-item>
          </el-form>
<!--          <el-button-->
<!--              style="margin-bottom: 20px"-->
<!--              type="primary"-->
<!--              plain-->
<!--              icon="el-icon-plus"-->
<!--              size="mini"-->
<!--              @click="handleAdd"-->
<!--          >新增</el-button>-->
          <el-table v-loading="loading" :data="tableList" border>
            <el-table-column label="姓名" align="center" prop="name" />
            <el-table-column label="媒体" align="center" prop="media" />
            <el-table-column label="手机号" align="center" prop="phone" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button
                    v-if="hasSelectPermission"
                    size="mini"
                    type="text"
                    icon="el-icon-user"
                    @click="getDetail(scope.row)"
                >查看详情</el-button>
                <el-button
                    v-if="hasUpdatePermission"
                    size="mini"
                    type="text"
                    icon="el-icon-user"
                    @click="handleUpdate(scope.row)"
                >修改</el-button>
                <el-button
                    v-if="hasDelPermission"
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-dialog
          title="详情"
          :visible.sync="dialogVisible"
          width="30%">
        <p>负责平台号：{{list1}}</p>
        <p>管理平台号：{{list2}}</p>
        <p>问题案例：{{num}}</p>
        <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
      </el-dialog>
      <el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
        <el-row :gutter="15">
          <el-form ref="form" :model="form"
                   :rules="rules"
                   size="medium"
                   label-width="100px">
            <el-col :span="12">
              <el-form-item label="岗位" prop="name">
                <el-select v-model="form.type" filterable placeholder="请选择">
                  <el-option
                      v-for="item in listItems"
                      :label="item.label"
                      :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入姓名" clearable >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所属单位" prop="director">
                <el-select v-model="form.media"
                           placeholder="请选择"
                           filterable
                           default-first-option>
                  <el-option
                      v-for="item in deptOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="time">
                <el-input v-model="form.phone" placeholder="请输入联系方式" clearable >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import request from "@/utils/request";
import {mapState} from "vuex";

export default {
  name: "responsibility",
  data(){
    return{
      open: false,
      dialogVisible: false,
      tableList: [],
      listItems: [
        { label: '运行专员' },
        { label: '媒体负责人' },
        { label: '媒体分管负责人' },
        { label: '账号负责人' },
        { label: '账号编辑' },
      ],
      type: '运行专员',
      search: '',
      list1: '',
      list2: '',
      num: '',
      deptOptions: [],
      title: '',
      form: {},
    }
  },
  created() {
    this.getList()
    this.getDept()
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasSelectPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_name_select');
    },
    hasAddPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_name_add');
    },
    hasDelPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_name_del');
    },
    hasUpdatePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_name_update');
    },
  },
  methods: {
    getList(e) {
      if (e) {
        this.type = e
      }
      axios.get(`/api/roster/list/${this.type}`)
          .then(response => {
            this.tableList = response.data;
          })
    },
    getDept() {
      axios.get("/api/dept/getList").then(res => {
        this.deptOptions = res.data
      })
    },
    reset() {
      this.form = {
        id: null,
        name: null,
        phone: null,
        media: null,
        type: null
      };
    },
    handleAdd() {
      this.reset();
      this.form.id = undefined
      this.open = true;
      this.title = "添加信息";
    },
    cancel() {
      this.open = false;
    },
    submitForm() {
      if (this.form.id !== undefined) {
        request.put('/roster/update/'+this.form.id,this.form).then(response => {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.open = false;
          this.getList();
        });
      } else {
        request.post('/roster/add',this.form).then(response => {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.open = false;
          this.getList();
        });
      }

    },
    handleUpdate(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "修改信息";
    },
    handleDelete(row){
      const ids = row.id;
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete('/roster/delete/' + ids).then(res=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleQuery() {
      const name = this.search
      axios.get(`/api/roster/list2/${name}`).then(res => {
        this.tableList = res.data;      })
    },
    getDetail(row){
      this.dialogVisible = true
      const data = row.name
      request.get('/pth/getList',{
        params: {
          director: data,
        }
      }).then(res =>{
        // console.log(res.data)
        if ( res.data.records.length === 0) {
          this.list1 = '无'
        }else {
          this.list1 = res.data.records.map(item => item.name + "(" + item.platform + ")").join(', ');
        }
      })
      request.get('/pth/getList',{
        params: {
          administrators: data,
        }
      }).then(res =>{
        // console.log(res.data)
        if ( res.data.records.length === 0) {
          this.list2 = '无'
        }else {
          this.list1 = res.data.records.map(item => item.name + "(" + item.platform + ")").join(', ');
        }

      })
      request.get('/mistake/getList',{
        params:{
          director: data
        }
      }).then(res =>{
        this.num = res.length
      })
    }
  }
}
</script>

<style scoped>
.li {
  display: flex;
  justify-content: center;
}
.li-item {
  margin: 20px 0;
  text-align: left;
  cursor: pointer;
}
</style>